import { Link } from 'react-router-dom';
import './ProductCard.css';

// One product in a grid (home page, collection pages). Takes a product in the
// products-table shape and links to /product/:slug.
export default function ProductCard({ product }) {
  var images = product.images || [];
  var photo = images[0];
  var hoverPhoto = images[1];
  var colours = product.colours || [];

  return (
    <Link to={'/product/' + product.slug} className="product-card">
      {photo ? (
        <div className={'product-card__img product-card__img--has-photo' + (hoverPhoto ? ' product-card__img--has-second' : '')}>
          <img src={photo} alt={product.name} />
          {hoverPhoto && (
            <img src={hoverPhoto} alt="" aria-hidden="true" className="product-card__img-second" />
          )}
        </div>
      ) : (
        <div className="product-card__img">Product photo</div>
      )}
      <div className="product-card__info">
        <span className="product-card__tag">{product.category}</span>
        <h3 className="product-card__name" title={product.name}>{product.name}</h3>
        <p className="product-card__desc">{product.materials}</p>
        <span className="product-card__price">{'$' + product.base_price}</span>
        <div className="product-card__colors">
          {colours.map(function(colour) {
            return (
              <span className="color-dot" key={colour.id} style={{ background: colour.hex_code }} title={colour.name}></span>
            );
          })}
        </div>
      </div>
    </Link>
  );
}
